import { FC } from 'react';
import { Oval } from 'react-loader-spinner';

export const SmallLoader: FC<{ height?: number; width?: number }> = ({
  height = 20,
  width = 20,
}) => {
  return (
    <span
      style={{ display: 'flex', justifyContent: 'center' }}
      className="louder-small-wrapper-custom"
    >
      <Oval secondaryColor="grey" color="#fff" height={height} width={width} />
    </span>
  );
};
